export default __webpack_public_path__ + "static/media/addToFavorite.ce5bf53a.svg";